import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async action to fetch company detail list data
export const getCustomerAddressById = createAsyncThunk(
  "customerAddressByIdList/getCustomerAddressById",
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/customerAddress/get_by_id`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const customerAddressGetByIdSlice = createSlice({
  name: "customerAddressByIdList",
  initialState: {
    loading: false,
    customerAddressbyIdListData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerAddressById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCustomerAddressById.fulfilled, (state, action) => {
        state.loading = false;
        state.customerAddressbyIdListData = action.payload;
      })
      .addCase(getCustomerAddressById.rejected, (state, action) => {
        state.loading = false;
        state.customerAddressbyIdListData = action.payload;
        state.error = action.payload;
      });
  },
});

export default customerAddressGetByIdSlice.reducer;
